export const privacyContent = {
  it: {
    title: "Informativa sulla Privacy",
    subtitle: "Politica sulla protezione dei dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR)",
    lastUpdated: "Ultimo aggiornamento: Aprile 2026",
    company: "SI.SA. LINE S.R.L.",
    companyDescription: "Azienda specializzata nella progettazione, produzione e installazione di segnaletica",
    sections: [
      {
        id: "titolare",
        title: "1. Titolare del Trattamento",
        content: [
          "Il Titolare del trattamento dei dati personali è SI.SA. LINE S.R.L. (di seguito \"Titolare\" o \"Società\"), azienda specializzata nella progettazione, produzione e installazione di segnaletica stradale, aziendale, pubblicitaria e di sicurezza.",
          "Sede legale: Via Monferrato, 20, 20098 San Giuliano Milanese (MI), Italia.",
          "Partita IVA: 14184310960",
          "Per qualsiasi richiesta relativa al trattamento dei Suoi dati personali, può contattarci all'indirizzo email: info@sisaline.it"
        ]
      },
      {
        id: "dati-raccolti",
        title: "2. Dati Personali Raccolti",
        content: [
          "Nell'ambito della propria attività di segnaletica, la Società raccoglie e tratta le seguenti categorie di dati personali:",
          "Dati di contatto e identificativi: nome, cognome, denominazione aziendale, indirizzo email, numero di telefono, indirizzo della sede o del cantiere, e qualifica professionale, forniti tramite il modulo di contatto, richieste di preventivo o comunicazioni dirette.",
          "Dati relativi a richieste di preventivo e progetti: informazioni tecniche relative ai progetti di segnaletica richiesti, quali specifiche tecniche, planimetrie, fotografie dei luoghi di installazione, requisiti normativi e indicazioni progettuali.",
          "Dati contrattuali e di fatturazione: ragione sociale, partita IVA, codice fiscale, coordinate bancarie, indirizzo di fatturazione e cronologia degli ordini e delle commesse, necessari per l'esecuzione dei contratti e degli obblighi fiscali.",
          "Dati di navigazione e analytics: indirizzo IP, tipo di browser, sistema operativo, pagine visitate, durata della sessione e interazioni con il sito web, raccolti automaticamente tramite cookie e strumenti di analisi.",
          "Dati per la newsletter: indirizzo email e preferenze di comunicazione forniti per l'iscrizione alla nostra newsletter relativa a novità, prodotti e normative del settore segnaletica."
        ]
      },
      {
        id: "finalita",
        title: "3. Finalità del Trattamento",
        content: [
          "I Suoi dati personali sono trattati per le seguenti finalità:",
          "Gestione delle richieste di contatto e preventivo: rispondere alle Sue richieste di informazioni, elaborare preventivi personalizzati per progetti di segnaletica, fornire consulenza tecnica e normativa.",
          "Esecuzione dei contratti: gestione delle commesse di segnaletica, coordinamento della progettazione e installazione, emissione di fatture e documenti fiscali, gestione dei rapporti con fornitori e subappaltatori.",
          "Assistenza post-vendita: gestione della manutenzione, riparazioni, sostituzioni e garanzie sui prodotti di segnaletica installati.",
          "Analisi e miglioramento del servizio: monitoraggio delle prestazioni del sito, analisi del comportamento degli utenti e ottimizzazione dell'esperienza di navigazione.",
          "Comunicazioni commerciali: invio di newsletter con aggiornamenti su nuovi prodotti di segnaletica, normative di settore, progetti realizzati e offerte promozionali (previo consenso esplicito).",
          "Adempimenti legali e normativi: conformità agli obblighi di legge, risposta a richieste delle autorità competenti, rispetto delle normative sulla sicurezza stradale e sul lavoro."
        ]
      },
      {
        id: "base-giuridica",
        title: "4. Base Giuridica del Trattamento",
        content: [
          "Il trattamento dei Suoi dati personali si fonda sulle seguenti basi giuridiche ai sensi dell'art. 6 del Regolamento (UE) 2016/679 (GDPR):",
          "Esecuzione di un contratto o misure precontrattuali (Art. 6.1.b): per la gestione delle richieste di preventivo, l'elaborazione di progetti di segnaletica e l'esecuzione delle commesse contrattuali.",
          "Consenso (Art. 6.1.a): per l'invio di comunicazioni commerciali e newsletter, e per l'utilizzo di cookie non essenziali.",
          "Legittimo interesse (Art. 6.1.f): per le attività di analisi e miglioramento del servizio, prevenzione delle frodi e sicurezza informatica.",
          "Obbligo legale (Art. 6.1.c): per gli adempimenti fiscali, contabili, le normative sulla sicurezza stradale e le richieste delle autorità competenti."
        ]
      },
      {
        id: "cookie",
        title: "5. Cookie e Tecnologie di Tracciamento",
        content: [
          "Il nostro sito utilizza cookie e tecnologie simili per garantire il corretto funzionamento, migliorare l'esperienza utente e raccogliere dati di analisi.",
          "Cookie tecnici (essenziali): necessari per il funzionamento del sito, la gestione della sessione utente e la sicurezza. Non richiedono il consenso dell'utente.",
          "Cookie analitici: utilizzati per raccogliere dati statistici anonimi sull'utilizzo del sito tramite strumenti come Google Analytics. Questi ci aiutano a comprendere come gli utenti interagiscono con il nostro sito e quali sezioni del catalogo segnaletica sono più consultate.",
          "Cookie di profilazione: utilizzati per creare profili relativi all'utente e inviare comunicazioni pubblicitarie personalizzate in base ai prodotti di segnaletica consultati. Richiedono il consenso esplicito dell'utente.",
          "L'utente può gestire le preferenze sui cookie in qualsiasi momento tramite il banner dei cookie presente sul sito o attraverso le impostazioni del proprio browser."
        ]
      },
      {
        id: "conservazione",
        title: "6. Periodo di Conservazione",
        content: [
          "I dati personali sono conservati per il tempo strettamente necessario al perseguimento delle finalità per cui sono stati raccolti:",
          "Dati relativi a richieste di preventivo: per 24 mesi dalla richiesta, salvo che il preventivo si trasformi in contratto.",
          "Dati contrattuali e di fatturazione: per 10 anni dalla conclusione del contratto, come previsto dalla normativa fiscale e civilistica italiana.",
          "Dati relativi a progetti e installazioni: per la durata della garanzia dei prodotti installati e comunque non oltre 10 anni, per eventuali esigenze di manutenzione o contestazioni.",
          "Dati di navigazione e analytics: per un massimo di 26 mesi dalla raccolta, successivamente vengono anonimizzati.",
          "Dati per la newsletter: fino alla revoca del consenso da parte dell'utente."
        ]
      },
      {
        id: "diritti",
        title: "7. Diritti dell'Interessato",
        content: [
          "Ai sensi degli articoli 15-22 del GDPR, Lei ha il diritto di:",
          "Diritto di accesso (Art. 15): ottenere conferma del trattamento dei Suoi dati e accedere alle informazioni relative, inclusi i dettagli dei progetti di segnaletica a Lei associati.",
          "Diritto di rettifica (Art. 16): richiedere la correzione di dati personali inesatti o l'integrazione di dati incompleti.",
          "Diritto alla cancellazione (Art. 17): richiedere la cancellazione dei Suoi dati personali quando non sono più necessari rispetto alle finalità per cui sono stati raccolti.",
          "Diritto di limitazione (Art. 18): richiedere la limitazione del trattamento in determinate circostanze.",
          "Diritto alla portabilità (Art. 20): ricevere i Suoi dati in un formato strutturato, di uso comune e leggibile da dispositivo automatico.",
          "Diritto di opposizione (Art. 21): opporsi in qualsiasi momento al trattamento dei Suoi dati per finalità di marketing diretto.",
          "Per esercitare i Suoi diritti, può inviare una richiesta a: info@sisaline.it"
        ]
      },
      {
        id: "destinatari",
        title: "8. Destinatari dei Dati",
        content: [
          "I Suoi dati personali possono essere comunicati a:",
          "Collaboratori e dipendenti autorizzati: personale tecnico, commerciale e amministrativo della Società, debitamente istruito e autorizzato al trattamento.",
          "Fornitori di materiali e subappaltatori: aziende coinvolte nella realizzazione dei progetti di segnaletica, limitatamente ai dati necessari per l'esecuzione della commessa.",
          "Professionisti e consulenti: commercialisti, avvocati e consulenti tecnici per l'adempimento di obblighi legali e contrattuali.",
          "Fornitori di servizi IT e hosting: per la gestione e manutenzione dei sistemi informatici e del sito web.",
          "Fornitori di servizi di analytics: per l'analisi statistica dell'utilizzo del sito.",
          "Autorità competenti: enti pubblici, organi di vigilanza e autorità giudiziarie quando richiesto per legge o per tutela dei diritti della Società.",
          "Tutti i fornitori esterni sono stati selezionati e, ove necessario, nominati Responsabili del trattamento ai sensi dell'art. 28 del GDPR."
        ]
      },
      {
        id: "sicurezza",
        title: "9. Misure di Sicurezza",
        content: [
          "La Società adotta misure tecniche e organizzative adeguate per proteggere i dati personali da accessi non autorizzati, perdita, distruzione o alterazione, tra cui:",
          "Cifratura dei dati in transito (SSL/TLS) per tutte le comunicazioni via sito web.",
          "Sistemi di archiviazione sicuri per i documenti progettuali e le informazioni dei clienti.",
          "Controlli di accesso basati sui ruoli per il personale autorizzato.",
          "Backup regolari dei dati e procedure di disaster recovery.",
          "Formazione periodica del personale in materia di protezione dei dati personali."
        ]
      },
      {
        id: "trasferimento",
        title: "10. Trasferimento dei Dati Extra-UE",
        content: [
          "I Suoi dati personali sono trattati e conservati prevalentemente all'interno dell'Unione Europea. Qualora alcuni fornitori di servizi (ad esempio, servizi cloud o analytics) fossero ubicati al di fuori dello Spazio Economico Europeo (SEE), il trasferimento dei dati avviene nel rispetto delle garanzie previste dal GDPR, tra cui:",
          "Decisioni di adeguatezza della Commissione Europea.",
          "Clausole contrattuali standard (SCC) approvate dalla Commissione Europea.",
          "Certificazioni o codici di condotta approvati."
        ]
      },
      {
        id: "reclamo",
        title: "11. Diritto di Reclamo",
        content: [
          "Qualora ritenga che il trattamento dei Suoi dati personali violi il GDPR, Lei ha il diritto di proporre reclamo all'Autorità Garante per la protezione dei dati personali:",
          "Garante per la Protezione dei Dati Personali - Piazza Venezia 11, 00187 Roma - www.garanteprivacy.it"
        ]
      },
      {
        id: "modifiche",
        title: "12. Modifiche alla Privacy Policy",
        content: [
          "La presente informativa può essere soggetta a modifiche e aggiornamenti, anche in relazione all'evoluzione della normativa sulla segnaletica e sulla protezione dei dati. Eventuali variazioni saranno pubblicate su questa pagina con indicazione della data di ultimo aggiornamento.",
          "Si consiglia di consultare periodicamente questa pagina per rimanere aggiornati sulle modalità di protezione dei dati personali adottate dalla Società."
        ]
      }
    ]
  },
  en: {
    title: "Privacy Policy",
    subtitle: "Personal Data Protection Policy under Regulation (EU) 2016/679 (GDPR)",
    lastUpdated: "Last updated: April 2026",
    company: "SI.SA. LINE S.R.L.",
    companyDescription: "Company specializing in the design, production and installation of signage",
    sections: [
      {
        id: "controller",
        title: "1. Data Controller",
        content: [
          "The Data Controller for personal data processing is SI.SA. LINE S.R.L. (hereinafter \"Controller\" or \"Company\"), a company specializing in the design, production, and installation of road, corporate, advertising, and safety signage.",
          "Registered office: Via Monferrato, 20, 20098 San Giuliano Milanese (MI), Italy.",
          "VAT Number: 14184310960",
          "For any requests regarding the processing of your personal data, you can contact us at: info@sisaline.it"
        ]
      },
      {
        id: "data-collected",
        title: "2. Personal Data Collected",
        content: [
          "In the course of its signage business activities, the Company collects and processes the following categories of personal data:",
          "Contact and identification data: first name, last name, company name, email address, phone number, office or job site address, and professional title, provided through the contact form, quote requests, or direct communications.",
          "Quote request and project data: technical information related to requested signage projects, including technical specifications, floor plans, photographs of installation locations, regulatory requirements, and design indications.",
          "Contractual and billing data: company name, VAT number, tax identification number, bank details, billing address, and order and commission history, necessary for contract execution and tax compliance.",
          "Browsing and analytics data: IP address, browser type, operating system, pages visited, session duration, and website interactions, automatically collected through cookies and analytics tools.",
          "Newsletter data: email address and communication preferences provided for subscribing to our newsletter about signage industry news, products, and regulations."
        ]
      },
      {
        id: "purposes",
        title: "3. Purposes of Processing",
        content: [
          "Your personal data is processed for the following purposes:",
          "Managing contact and quote requests: responding to your information requests, preparing customized quotes for signage projects, providing technical and regulatory consultancy.",
          "Contract execution: managing signage commissions, coordinating design and installation, issuing invoices and tax documents, managing relationships with suppliers and subcontractors.",
          "After-sales assistance: managing maintenance, repairs, replacements, and warranties on installed signage products.",
          "Service analysis and improvement: website performance monitoring, user behavior analysis, and browsing experience optimization.",
          "Commercial communications: sending newsletters with updates on new signage products, industry regulations, completed projects, and promotional offers (with explicit consent).",
          "Legal and regulatory compliance: compliance with legal obligations, responding to requests from competent authorities, compliance with road safety and occupational health regulations."
        ]
      },
      {
        id: "legal-basis",
        title: "4. Legal Basis for Processing",
        content: [
          "The processing of your personal data is based on the following legal bases under Article 6 of Regulation (EU) 2016/679 (GDPR):",
          "Contract performance or pre-contractual measures (Art. 6.1.b): for managing quote requests, developing signage projects, and executing contractual commissions.",
          "Consent (Art. 6.1.a): for sending commercial communications and newsletters, and for the use of non-essential cookies.",
          "Legitimate interest (Art. 6.1.f): for service analysis and improvement activities, fraud prevention, and IT security.",
          "Legal obligation (Art. 6.1.c): for tax and accounting obligations, road safety regulations, and authority requests."
        ]
      },
      {
        id: "cookies",
        title: "5. Cookies and Tracking Technologies",
        content: [
          "Our website uses cookies and similar technologies to ensure proper functioning, improve user experience, and collect analytics data.",
          "Technical cookies (essential): necessary for website operation, user session management, and security. They do not require user consent.",
          "Analytics cookies: used to collect anonymous statistical data on website usage through tools such as Google Analytics. These help us understand how users interact with our site and which signage catalog sections are most viewed.",
          "Profiling cookies: used to create user profiles and send personalized advertising communications based on signage products viewed. They require explicit user consent.",
          "Users can manage cookie preferences at any time through the cookie banner on the website or through their browser settings."
        ]
      },
      {
        id: "retention",
        title: "6. Data Retention Period",
        content: [
          "Personal data is retained for the time strictly necessary to achieve the purposes for which it was collected:",
          "Quote request data: for 24 months from the request, unless the quote results in a contract.",
          "Contractual and billing data: for 10 years from the conclusion of the contract, as required by Italian tax and civil legislation.",
          "Project and installation data: for the duration of the warranty on installed products and in any case no longer than 10 years, for maintenance needs or potential disputes.",
          "Browsing and analytics data: for a maximum of 26 months from collection, after which they are anonymized.",
          "Newsletter data: until consent is withdrawn by the user."
        ]
      },
      {
        id: "rights",
        title: "7. Data Subject Rights",
        content: [
          "Under Articles 15-22 of the GDPR, you have the right to:",
          "Right of access (Art. 15): obtain confirmation of the processing of your data and access related information, including details of signage projects associated with you.",
          "Right to rectification (Art. 16): request correction of inaccurate personal data or completion of incomplete data.",
          "Right to erasure (Art. 17): request deletion of your personal data when no longer necessary for the purposes for which it was collected.",
          "Right to restriction (Art. 18): request restriction of processing in certain circumstances.",
          "Right to data portability (Art. 20): receive your data in a structured, commonly used, and machine-readable format.",
          "Right to object (Art. 21): object at any time to the processing of your data for direct marketing purposes.",
          "To exercise your rights, you can send a request to: info@sisaline.it"
        ]
      },
      {
        id: "recipients",
        title: "8. Data Recipients",
        content: [
          "Your personal data may be shared with:",
          "Authorized employees and collaborators: technical, commercial, and administrative staff of the Company, duly trained and authorized for data processing.",
          "Material suppliers and subcontractors: companies involved in the execution of signage projects, limited to the data necessary for commission execution.",
          "Professionals and consultants: accountants, lawyers, and technical consultants for fulfilling legal and contractual obligations.",
          "IT and hosting service providers: for the management and maintenance of IT systems and the website.",
          "Analytics service providers: for statistical analysis of website usage.",
          "Competent authorities: public bodies, supervisory authorities, and judicial authorities when required by law or to protect the Company's rights.",
          "All external providers have been selected and, where necessary, appointed as Data Processors under Article 28 of the GDPR."
        ]
      },
      {
        id: "security",
        title: "9. Security Measures",
        content: [
          "The Company adopts appropriate technical and organizational measures to protect personal data from unauthorized access, loss, destruction, or alteration, including:",
          "Data encryption in transit (SSL/TLS) for all website communications.",
          "Secure archiving systems for project documents and client information.",
          "Role-based access controls for authorized personnel.",
          "Regular data backups and disaster recovery procedures.",
          "Periodic staff training on personal data protection."
        ]
      },
      {
        id: "transfer",
        title: "10. Data Transfer Outside the EU",
        content: [
          "Your personal data is primarily processed and stored within the European Union. Should some service providers (e.g., cloud or analytics services) be located outside the European Economic Area (EEA), data transfer occurs in compliance with the guarantees provided by the GDPR, including:",
          "Adequacy decisions of the European Commission.",
          "Standard Contractual Clauses (SCCs) approved by the European Commission.",
          "Approved certifications or codes of conduct."
        ]
      },
      {
        id: "complaint",
        title: "11. Right to Lodge a Complaint",
        content: [
          "If you believe that the processing of your personal data violates the GDPR, you have the right to lodge a complaint with the Data Protection Authority:",
          "Garante per la Protezione dei Dati Personali - Piazza Venezia 11, 00187 Roma - www.garanteprivacy.it"
        ]
      },
      {
        id: "changes",
        title: "12. Changes to This Privacy Policy",
        content: [
          "This privacy policy may be subject to changes and updates, including in relation to evolving signage regulations and data protection legislation. Any modifications will be published on this page with an indication of the last update date.",
          "We recommend periodically checking this page to stay informed about the personal data protection methods adopted by the Company."
        ]
      }
    ]
  }
};
